export { default } from './ProfilePage';



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/profile/index.ts